module.exports = __webpack_public_path__ + "img/bg2.78352275.png";